module.exports = __webpack_public_path__ + "static/media/paratomar_checked.5d757d18.svg";